/**
 * Normalizes the match markets data into a user-friendly structure.
 *
 * @param {Object} data - The raw data object containing market IDs and their statuses.
 * @param {number} matchId - The match ID associated with the data.
 * @returns {Object} - The normalized object.
 */
function normalizeMatchMarkets(data, matchId) {
  // Extract the status key and transform the rest of the data
  const { status, ...markets } = data;

  let normalizedMarkets = {};

  // Transform the markets into an array of objects
  normalizedMarkets = Object.entries(markets).map(([marketId, isBetstop]) => ({
    marketId: Number(marketId),
    isBetstop,
  }));

  return {
    matchId,
    markets: normalizedMarkets,
  };
}

export default normalizeMatchMarkets;
